import { CardSvg } from '@/play/cardSvg'

/** Home card art: lumps and coils of modelling clay on a wooden board. */
export function ClayCardArt() {
  return (
    <CardSvg bg="#e9e4da">
      <path d="M20 168 L 60 120 H 290 L 300 168 Z" fill="#c9a77c" />
      <path d="M20 168 H 300 V 178 H 20 Z" fill="#b08d63" />
      {/* a terracotta lump with a blue patch pressed on top */}
      <path d="M90 150 C 84 124, 104 104, 130 106 C 156 108, 168 128, 162 148 C 150 156, 104 158, 90 150 Z" fill="#c0673f" />
      <path d="M112 116 C 120 108, 138 108, 146 118 C 140 126, 120 126, 112 116 Z" fill="#3f7cc4" />
      <ellipse cx="136" cy="134" rx="9" ry="5" fill="#1d2b36" opacity="0.12" />
      {/* a yellow coil and a red blob */}
      <path d="M190 146 C 200 128, 230 130, 236 142 C 242 154, 262 150, 268 136" stroke="#f2c14e" strokeWidth="11" fill="none" strokeLinecap="round" />
      <ellipse cx="222" cy="128" rx="13" ry="10" fill="#d9483b" />
      <circle cx="252" cy="122" r="7" fill="#5aa357" />
    </CardSvg>
  )
}
